import {ModuleService} from "@/services/ModuleService";

const state = {
  moduleKeys : [],
  moduleLists : []
}

const mutations = {
  setModuleKeys: (state, moduleKeys) => state.moduleKeys = moduleKeys,
  setModuleLists: (state, moduleLists) => state.moduleLists = moduleLists,
}

const actions = {
  async getModuleKeys({commit}, params) {
    const moduleKeys = await ModuleService.getModuleKeys(params)
    if (moduleKeys) commit('setModuleKeys', moduleKeys)
  },
}

const getters = {
  moduleKeys : state => state.moduleKeys,
}

export default {
  namespaced : true,
  state,
  mutations,
  actions,
  getters
}
